<template>
    <div>
        <div class="today--tickets mb-4">
            <div class="bg-sky mb-3 pb-3 pb-lg-5">
                <v-header></v-header>
                <div class="container py-5">
                    <div class="row">
                        <div class="col">
                            <h1 class="text-white text-center text-uppercase" v-text="getTranslation('flexPageTitle')"></h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <banner></banner>

        <div class="ml-3 mr-3 mb-5 d-block d-md-none">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-md-3" v-for="(ticket, index) in tickets" :key="ticket.id">
                        <flex-ticket :data="ticket" :show="index === 0" :show-more-button="true"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="ml-3 mr-3 mb-3 d-none d-md-block">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 col-md-6 col-lg-3" v-for="(ticket, index) in tickets" :key="ticket.id">
                        <flex-ticket :data="ticket" :show="index === 0"/>
                    </div>
                </div>
            </div>
        </div>

        <sticky-footer></sticky-footer>
    </div>
</template>

<script>
    import FlexTicket from '../FlexTicket';
    import * as Actions from '../../store/action-types';
    import siteConfig from '../../mixins/siteConfig';

    export default {
        components: {
            FlexTicket
        },

        mixins: [siteConfig],

        mounted() {
            this.$store.dispatch(Actions.getFlexTickets);
        },

        computed: {
            tickets() {
                return this.$store.getters.flexTickets;
            },
        },
        watch: {
            tickets: {
                immediate: true,
                handler(newTickets) {
                    if (newTickets.length == 0) return
                    const items = [];
                    let i = 1;
                    newTickets.forEach(ticket => {
                        ticket.products.forEach(prod => {
                            items.push({
                                item_name: prod.ticket_name + " " + prod.person,
                                item_id: prod.product_id,
                                price: prod.price,
                                item_brand: "Valle Plus",
                                item_category: ticket.ax_name,
                                item_category2: prod.person,
                                index: i++,
                                quantity:1,
                                currency: "CLP"
                            })
                        })
                    });
                    dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                    dataLayer.push({
                        event: "view_item_list",
                        ecommerce: {
                            items: items
                        }
                    });
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/Pages/FlexPage.vue